import styled from "styled-components";

export const ProgressBar = styled.div.attrs({
  className: "progress-bar progress-bar-success progress-bar-striped active",
})`
  height: 18px;
  width: 100%;
`;

export const ProgressBarPercentage = ({
  $percentage,
  className,
  children,
  style,
}: {
  $percentage: number;
  className?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}) => {
  return (
    <div style={style}>
      <Label>{children}</Label>
      <div className={`progress ${className || ""}`}>
        <div
          className="progress-bar progress-bar-success progress-bar-striped active"
          role="progressbar"
          style={{ width: `${$percentage}%` }}
        ></div>
      </div>
    </div>
  );
};
const Label = styled.div`
  color: #fff;
  text-align: center;
  margin-bottom: 6px;
`;
